module.exports = __webpack_public_path__ + "img/dummy_cert_1.7a374cf4.jpg";